import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import Tabledevices from "../../comman/tableDevices";
import { useEffect, useState } from "react";
import DevicePhotosModal from "../../comman/devicePhotos";
import axios from "axios";
import { toast } from "react-toastify";
import fetchPaymentHistory from "../../../service/fetchPaymentHistory";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter";

const Base_Url = process.env.REACT_APP_BASE_URL;
export default function ViewUpcomingService()
{
  const {id}=useParams();
  const navigate=useNavigate();
  const location = useLocation();
  const activeStep = location.state?.activeStep || 1;
  const [loading,setLoading]=useState(false);
  const [service,setService]=useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDeviceIndex, setModalDeviceIndex] = useState(null);
  const [invoicePhase, setInvoicePhase] = useState(null);
  const [serviceInvoiceId,setServiceInvoiceId]=useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [serviceTrackData, setServiceTrackData] = useState(null);
    
  useEffect(() => {
    if (id) fetchBookedServices();
  }, [id]);


  useEffect(() => {
    const totalCostValue = parseFloat(service?.totalCost || 0);
    if (totalCostValue > 0) {
      setIsSubmitted(true);
    } else {
      setIsSubmitted(false);
    }
  }, [service?.totalCost]);

  const fetchBookedServices = async () => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token"); 

    const response = await axios.get(`${Base_Url}/api/bookedService/getBookedServiceDetails/${id}`, 
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      setService(response.data.data);
    } else {
      toast.error(response.data.message || "Failed to fetch data");
    }
  } catch (error) {
    console.error(error);
    toast.error(
      error.response?.data?.message || "Something went wrong while fetching"
    );
  } finally {
    setLoading(false);
  }
  };

  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${Base_Url}/api/serviceProcess/getInvoiceStepInfo/${service?.bookedServiceId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data.success && response.data.data) {
          const data = response.data.data;
          setInvoicePhase(data);   
          setServiceInvoiceId(data.invoice?.id);      
          console.log("✅ Invoice phase:", data);
        } else {
          console.error("❌ Error fetching Invoice phase message:", response.data.message);
        }
      } catch (error) {
        console.error("❌ Error fetching Invoice phase:", error);
      }
    };

    if (service?.bookedServiceId) fetchInvoiceDetails();
  }, [service?.bookedServiceId]);

  useEffect(() => {
    const fetchServiceTrack = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${Base_Url}/api/bookedService/trackBookedServiceCustomer/${service?.bookedServiceId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data.success && response.data.data) {
          const data = response.data.data;  
          setServiceTrackData(data);      
        } else {
          console.error("❌ Error fetching Invoice phase message:", response.data.message);
        }
      } catch (error) {
        console.error("❌ Error fetching Invoice phase:", error);
      }
    };

    if (service?.bookedServiceId) fetchServiceTrack();
  }, [service?.bookedServiceId]);
 
    useEffect(() => {
        const loadPaymentHistory = async () => {
          if (!serviceInvoiceId) return;  
          const data = await fetchPaymentHistory(serviceInvoiceId);
          if (data) {
            setPaymentData(data);
          }
        };
    
        if (serviceInvoiceId) loadPaymentHistory();
    }, [serviceInvoiceId]);

  const openModal = (deviceIndex) => {
    setModalDeviceIndex(deviceIndex);
    setSelectedIndex(0);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalDeviceIndex(null);
  };

  if (loading) {
    return <p className="text-center text-gray-500 py-10">Loading booked services...</p>;
  }

    return(
    <section className="px-5 py-5 md:px-5 lg:px-10 ">
      <button 
        className="flex flex-row space-x-2 items-center mb-5" 
        onClick={() => navigate("/bookedservices", { state: { activeStep } })}
      >
            <MdKeyboardBackspace className="text-base md:text-lg xl:text-xl" />
            <p className="text-sm md:text-base xl:text-lg font-medium">Service Details</p>
      </button> 
      {!service ? (
        <p>Service dtails not found </p>
      ) :(
      <div className="flex flex-col">
        {service.status==="cancelled" && (
            <p className="text-sm md:text-base xl:text-lg font-semibold pb-3">
              Cancel reason :{" "}
              <span className="text-red-500 ">
                {service.reason}
              </span>
            </p>
        )} 
        {service.status==="rejected" && (
          <div className="flex flex-col space-y-1">
            <p className="text-sm md:text-base xl:text-lg font-semibold pb-3">
              Rejected by :{" "}
              <span className="">
                {!service.clientApprovalReason ? "Asia link Computer" : "You"}
              </span>
            </p>
            <p className="text-sm md:text-base xl:text-lg font-semibold pb-3">
              Reject reason :{" "}
              <span className="text-red-500 ">
                {!service.clientApprovalReason ? service.reason : service.clientApprovalReason}
              </span>
            </p>
          </div>
        )}    
        <div className="w-full p-3 md:p-6 flex flex-col border-2 border-red-700 rounded-md">
          <p className="text-sm md:text-base xl:text-lg font-medium mb-3 text-[#A63F40]">Requested Details -</p>
              
          <div className="grid grid-cols-1 md:grid-cols-2 justify-between text-xs md:text-sm xl:text-base">
            <p className=""><strong>Person Name : </strong>{service.user?.name}</p>
            <p className=""><strong>Pickup Required : </strong>{service.pickupRequired ===true ? "Yes" : "No"}</p>
            <p className=""><strong>Contact No : </strong>{service.user?.mobileNumber}</p>
            <p className="">
              <strong>Pickup Date : </strong>
              {service.pickupRequired === false
                  ? "—"
                  : (service.pickupDate
                  ? new Date(service.pickupDate).toLocaleDateString("en-US", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                })
                : "—")}
            </p>      
            
            <p className="">
              <strong>Preferred Service Date : </strong>
              {service.preferredServiceDate
                  ? new Date(service.preferredServiceDate).toLocaleDateString("en-US", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                })
                : "—"}
            </p>
            <p className="">
              <strong>Preferred pickup Time Slot : </strong>
              {service.pickupRequired===false
                  ? "—"
                  : service.pickupTimeSlot || "—"}
            </p>

            <p className="">
              <strong>Notes : </strong>
              {service.additionalNotes || "—"}
            </p>
            <p className="">
              <strong>Address : </strong>
              {service.address
                  ? `${service.address.buildingBlock.toUpperCase()} - ${service.address.flatNo}, ${service.address.buildingName}, ${service.address.landmark || ""}, ${service.address.streetName || ""}, ${service.address.city}, ${service.address.state}, ${service.address.pincode}`
                  : "-"}
            </p>

          </div>
          <h2 className="text-lg font-semibold text-[#A63F40] mb-2">Devices:</h2>
          <div className="overflow-x-auto">
            <Tabledevices request={service} openModal={openModal} />
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start space-y-5 md:space-x-5 md:space-y-0 mt-8">

        <div className="w-full md:w-1/2 flex flex-col px-4 py-4 relative border-2 border-red-700 rounded-md">
        <p className="text-sm md:text-base xl:text-lg font-medium mb-2 text-[#A63F40]">Service Track</p>
        <div className="mt-3 space-y-4 lg:ml-12">
          {serviceTrackData?.map((item, index) => {
          const dateObj = new Date(item.createdAt);

          const formattedDate = dateObj.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });

          const formattedTime = dateObj.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: "Asia/Kolkata",
          });

          return (
          <div key={index} className="flex items-start gap-3 relative">
            <div 
              className={`rounded-full mt-2 w-3 h-3
              ${(item.status?.toLowerCase().includes("reject") || item.status?.toLowerCase().includes("cancel"))? "bg-red-500" : "bg-green-500"}
              `}
            ></div>

          {index !== serviceTrackData.length - 1 && (
            <div className="absolute left-[5px] top-5 w-[2px] h-full bg-green-500"></div>
          )}

          <div className="flex flex-col">
            <p 
              className={`text-sm md:text-base font-semibold  
                ${(item.status?.toLowerCase().includes("reject") || item.status?.toLowerCase().includes("cancel") ) ? "text-red-500" : "text-gray-800"}
              `}>
              {item.status}
            </p>
            <p className="text-xs md:text-sm text-gray-600">
              {formattedDate} • {formattedTime}
            </p>
          </div>
          </div>
          );
          })}
        </div>
        </div>

        <div className="w-full md:w-1/2 border-2 border-red-700 rounded-md px-6 py-6 md:py-8 text-sm xl:text-base space-y-4 md:space-y-6">
           {isSubmitted ? (
            <div className="flex justify-center items-center">
                <button
                  onClick={() => navigate(`/viewestimation/${service.bookedServiceId}`)}
                  className="flex justify-center rounded-md text-white bg-[#A63F40] px-3 py-2 w-36"
                >
                  View Estimation
                </button>
            </div>
           ) : (
            <div className="flex justify-center items-center text-[#A63F40] font-semibold text-center">
                <p className="">Estimation not received yet from Asia Link computer managegment</p>
            </div>
           )}

           {invoicePhase && (
              <div className="flex justify-center items-center">
                <button
                 onClick={() => navigate(`/viewinvoice/${service.bookedServiceId}`)}
                 className="flex justify-center rounded-md text-white bg-[#A63F40] px-3 py-2 w-36">
                  View Invoice
                </button>
              </div>
            )}

            {paymentData && (
              <div className="space-y-3">
              <p className="text-sm lg:text-base">
                <span className="font-semibold">Current status :</span>{" "}
                <span
                  className={
                    paymentData?.status?.toLowerCase() === "completed"
                      ? "text-green-600"
                      : "text-yellow-500"
                  }
                >
                  {capitalizeFirstLetter(paymentData.status)}
                </span>
              </p>
              <p className="text-sm lg:text-base">
                <span className="font-semibold">Total Amount :</span>{" "}
                <span className="">
                 {paymentData.totalCost}
                </span>
              </p>
              <p className="text-sm lg:text-base">
                <span className="font-semibold">Total Paid :</span>{" "}
                <span  className="">
                 {paymentData.totalPaid}
                </span>
              </p> 
              <p className="text-sm lg:text-base">
                <span className="font-semibold">Remaining amount :</span>{" "}
                <span  className="">
                 {paymentData.totalCost - paymentData.totalPaid}
                </span>
              </p> 
              <ul className="mt-10 text-sm text-gray-700 space-y-3">
                  {paymentData.payments?.map((p, idx) => (
                          <li
                            key={idx}
                            className="grid grid-cols-2 lg:grid-cols-4 px-2 py-2 rounded-lg bg-[#ffeeee] font-medium text-black shadow-md "
                          >
                            <span className="text-center">
                              {" "}
                              {p.confirmDate}{" "}
                            </span>
                            <span className="text-center">
                              Paid ₹{p.paymentInstallment}
                            </span>
                            <span className="text-center">
                              Via {p.paymentMode}
                            </span>
                            <span className="text-center">
                              (Ref: {p.referenceId || "N/A"})
                            </span>
                          </li>
                        ))}
                      </ul>
            </div>
            )}

            

        </div>

        </div>
        
      </div>

      )}

      <DevicePhotosModal
        isOpen={modalOpen}
        onClose={closeModal}
        device={modalDeviceIndex !== null ? {issue_photos: modalDeviceIndex} : null}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />
    </section>
    );
}